<template>
    <div class="bd-page">
        <div class="bd-gradient" aria-hidden="true"></div>
        <main class="bd-content">
            <section class="bd-hero">
                <h1 class="bd-title">
                    <span>Climate Philanthropy &amp; Business International Dialogue, Shanghai</span><br />
                    <div class="sub-title-images">
                        <img src="https://gf60.org.cn/upload/owe/79aa4879da3a4411bf062f8ecf4b8046.jpg" alt="Friends of the Paris Agreement" />
                        <img src="https://gf60.org.cn/upload/owe/28b81d68f134497a92fa315a91b77e7a.jpg" alt="Diverse Stakeholders Communication 2025" />
                    </div>
                </h1>
                <div class="line-box">
                    <div data-v-0223ecb8="" class="arrow"></div>
                </div>
                <p class="bd-subtitle">10 Years of Partnership, Pioneering Climate Solutions</p>
                <ul class="bd-meta">
                    <li>
                        <strong>Date:</strong>
                        Sunday, 19 October 2025
                    </li>
                    <li>
                        <strong>Venue:</strong>
                        North Bund, Shanghai, China
                    </li>
                </ul>
            </section>

            <section class="bd-intro-box">
                <div class="bd-intro-content">
                    <div class="bd-intro-image">
                        <img src="https://gf60.org.cn/upload/owe/a46962eb9a9e4d7c906926bc33f6d207.jpg" alt="Climate Philanthropy & Business International Dialogue" />
                    </div>
                    <div class="bd-intro-text">
                        <p class="bd-intro-para">
                            On 19 October 2025, the Climate Philanthropy & Business International Dialogue was successfully convened in Shanghai, uniting leaders from the UN, philanthropic foundations, financial institutions, governments, think-tanks and the private sector to review progress since the Paris Agreement. The whole-day event conducted 6 rounds of in-depth and diverse discussions, covering critical issues such as scaling up climate finance, pathways to 2035 NDC targets, and fostering innovative partnerships.
                        </p>
                        <p class="bd-intro-para">
                            The Dialogue reached important consensus on climate governance and energy-transition pathways, with climate-finance innovation emerging as the central theme. Participants stressed the need to close the trillion-dollar financing gap through blended-finance structures and philanthropic capital leverage, while building a diversified investment and financing system that covers green technologies, transition finance and adaptation projects.
                        </p>
                        <p class="bd-intro-para">
                            It was recognized that global climate action has entered a decisive implementation phase, demanding systemic innovation to overcome finance, technology, and cooperation bottlenecks. Integrating philanthropic and commercial capital is crucial, with philanthropic funds acting as patient capital and risk-mitigation tools—particularly to support Global South needs and lower barriers for green-technology and clean-energy investment.
                        </p>
                        <p class="bd-intro-para">
                            The meeting proposed launching a Call-to-Action at COP30 to translate this consensus into greater outcomes for global climate governance in the coming decade.
                        </p>
                    </div>
                </div>
            </section>

            <section class="bd-section">
                <h2 class="bd-section-title">Background</h2>
                <div class="bd-body">
                    <p>
                        Since the signing of the Paris Agreement, global climate action has entered a critical decade.
                        During this period, the business and philanthropic communities have played an increasingly
                        prominent role in global climate governance, becoming a key force in advancing climate goals.
                        Data shows that global climate-related philanthropy grew by 20% year-on-year in 2023, reaching
                        USD 4.8 billion—three times the amount in 2019. Despite this rapid growth, funding for climate
                        mitigation still accounts for less than 2% of total global philanthropic giving, indicating
                        significant room for increased impact.
                    </p>
                    <p>
                        In response to the substantial global climate finance gap, multi-stakeholder collaboration
                        models such as blended finance have emerged in recent years. These approaches aim to mobilize
                        and integrate resources from governments, businesses, financial institutions, and philanthropic
                        foundations to advance green and low-carbon transitions. Such partnerships not only help to
                        unlock greater volumes of private capital for climate initiatives but also promote technological
                        innovation, offering new ideas and solutions for tackling climate change. As China’s economic
                        and financial hub and an international green finance center, Shanghai is well positioned to take
                        a leading role in this field.
                    </p>
                    <p>
                        The 2025 Climate Philanthropy & Business International Dialogue, Shanghai aims to convene global
                        thought-leaders across climate policy, philanthropy, multilaterals, academia and the private
                        sector to foster meaningful partnerships for higher climate ambition and joint action. The
                        dialogue will be presented by diverse stakeholders from the climate community in China,
                        including grassroot NGOs, climate tech innovators as well as city leadership, to share knowledge
                        and success stories, but also to reflect on the critical actions needed for scaling climate
                        solutions, mobilizing capital in emerging markets, and empowering SMEs as drivers of climate
                        transition.
                    </p>
                </div>
            </section>

            <section class="bd-section">
                <h2 class="bd-section-title">Organizers</h2>
                <div class="bd-organizers">
                    <div class="bd-org-group">
                        <div class="bd-org-label">Under the Guidance of</div>
                        <ul>
                            <li>China Environmental Protection Foundation</li>
                            <li>ZhenHua Green Transition and Sustainable Development Fund</li>
                        </ul>
                    </div>
                    <div class="bd-org-group">
                        <div class="bd-org-label">Host Organizers</div>
                        <ul>
                            <li>Green Finance Forum of 60 (GF60), Shanghai Jinsinan Institute of Finance</li>
                        </ul>
                    </div>
                    <div class="bd-org-group">
                        <div class="bd-org-label">Co-Organizer</div>
                        <ul>
                            <li>Institute of Climate Change and Sustainable Development, Tsinghua University</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="bd-section">
                <h2 class="bd-section-title">Agenda (Tentative)</h2>
                <div class="bd-timeline">
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">9:00–9:30</div>
                            <div class="bd-timeline-title">Welcome Remarks</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">9:30–10:00</div>
                            <div class="bd-timeline-title">Opening Remarks</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">10:00–10:50</div>
                            <div class="bd-timeline-title">
                                <strong>High-level Opening:</strong> "Friends of the Paris Agreement" Multi-Stakeholder
                                Dialogue 2015–2025 — Ten Years of Partnership, Pioneering Climate Solutions
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">10:50–11:10</div>
                            <div class="bd-timeline-title">Group photo &amp; coffee break</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">11:10–12:00</div>
                            <div class="bd-timeline-title">
                                <strong>Climate Finance in Focus:</strong> Unleashing the Catalytic Effect of Climate
                                Philanthropy
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">12:00–13:00</div>
                            <div class="bd-timeline-title">
                                <strong>Luncheon Session:</strong> "1.5°C Talk" — Special Remarks
                                <p class="bd-timeline-li">
                                    <strong>
                                        3–5 grassroots climate organizations will be invited to showcase their climate
                                        stories in a TED-talk style
                                    </strong>(15 mins each)
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">13:00–14:00</div>
                            <div class="bd-timeline-title">Lunch break</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">14:00–14:40</div>
                            <div class="bd-timeline-title">
                                <strong>Cities in Spotlight:</strong> Fireside chat with the Mayors'
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">14:40–16:00</div>
                            <div class="bd-timeline-title">
                                <p>Thematic Dialogue I: Toward Net-Zero: Ambition and Pathways</p>
                                <p>
                                    Thematic Dialogue II: Climate Blended Finance: Mobilizing Capital
                                    in China
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <!-- <div class="bd-timeline-dot"></div> -->
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time" style="font-weight: normal;">Parallel Activities</div>
                            <div class="bd-timeline-title">
                                <p>Side-event I: Empowering SMEs as Drivers of
                                    Climate Transition</p>
                                <p>
                                    Side-event II: China's Climate and Environment Grantmakers Actions
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">16:00–16:15</div>
                            <div class="bd-timeline-title">Coffee break</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">16:15–17:00</div>
                            <div class="bd-timeline-title">
                                <strong>Looking Forward:</strong> the next decade of Paris Agreement — Unlocking
                                Trillions for Transition through South-South Cooperation
                            </div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">17:00–17:30</div>
                            <div class="bd-timeline-title">Summary</div>
                        </div>
                    </div>
                    <div class="bd-timeline-item">
                        <div class="bd-timeline-dot"></div>
                        <div class="bd-timeline-content">
                            <div class="bd-timeline-time">17:30</div>
                            <div class="bd-timeline-title"><strong>End of program</strong></div>
                        </div>
                    </div>
                </div>
                <section class="bd-invitation">
                    <div class="bd-invitation-content">
                        <p class="bd-note">
                            This is a close-door by invitation-only event. Should you be interested in further details,
                            please get in touch via ---<a href="https://gf60.org.cn/contact-information" target="_blank"
                                rel="noopener noreferrer" class="bd-link">https://gf60.org.cn/contact-information</a>
                        </p>

                    </div>
                </section>
            </section>

            <section class="bd-section bd-organizations">
                <div class="bd-org-descriptions">
                    <div class="bd-org-item">
                        <div class="bd-org-logo">
                            <img src="https://gf60.org.cn/upload/owe/f0e013af3d0940938ee0f5383b690712.png"
                                alt="GF60 Logo" />
                        </div>
                        <div class="bd-org-text">
                            <p>
                                The GF60 is a non-profit international platform hosted by the Shanghai Jinsinan
                                Institute of Finance. GF60 convenes global leaders from governments, industries,
                                financial institutions, and academia to promote green finance innovation and facilitate
                                the transition to a green and low-carbon economy. GF60 has identified three focal areas
                                of crucial importance to China’s green finance systems: ESG, carbon market, and climate
                                finance. Through research and convening, GF60 aims to mobilize sustainable investment to
                                support the low-carbon transition, biodiversity conservation, and high-quality
                                development.
                            </p>
                        </div>
                    </div>
                    <div class="bd-org-item">
                        <div class="bd-org-logo">
                            <img src="https://gf60.org.cn/upload/owe/b929a14af9a24744a26d7518e8cd1645.png"
                                alt="China Environmental Protection Foundation Logo" />
                        </div>
                        <div class="bd-org-text">
                            <p>
                                The China Environmental Protection Foundation (CEPF) is the first nationwide
                                public-raising organization dedicated to environmental protection in China. Approved by
                                the State Council and administered by the Ministry of Ecology and Environment, CEPF is
                                registered with the Ministry of Civil Affairs. CEPF aims to raise funds for
                                environmental protection, support environmental projects, promote environmental
                                awareness, and facilitate the development of China’s environmental initiatives.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


        </main>
    </div>

</template>

<script>
export default {
    name: "BusinessDialogue",
};
</script>

<style scoped lang="less">
.bd-page {
    display: flex;
    justify-content: center;
    background: white;
    position: relative;
    font-size: 16px;
    font-family: "Source Han Sans CN", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

.bd-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 21rem;
    background: linear-gradient(0, rgba(185, 247, 195, 0.00) 0%, rgba(185, 247, 195, 0.13) 52.48%, rgba(130, 233, 250, 0.48) 134.9%);
    pointer-events: none;
    z-index: 0;
    //   opacity: 0.48;
}

.bd-content {
    width: 100%;
    max-width: 1068px;
    position: relative;
    z-index: 1;
}

.bd-hero {
    text-align: center;
    margin-bottom: 24px;
}

.bd-title {
    font-size: 32px;
    line-height: 1.35;
    color: #037698;
    font-weight: bold;
    margin: 48px 0 48px 0;

    .sub-title-images {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        margin-top: 48px;

        img {
            max-width: 100%;
            height: auto;
            display: block;
        }
    }

    span {
        font-weight: bold;
    }
}

.line-box {
    height: 1px;
    background: #037698;
    position: relative;
    margin-bottom: 32px;

    .arrow {
        width: 0;
        height: 0;
        border-color: transparent;
        border-top-color: #037698;
        border-width: 10px;
        border-style: solid;
        position: absolute;
        left: calc((100% - 10px) / 2);
    }
}

.bd-subtitle {
    color: #222;

    font-size: 21px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    /* 160% */
}

.bd-meta {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
    justify-content: center;
    color: #4a4a4a;

    li {
        color: var(--wenzi, #494949);
        text-align: justify;
        font-family: "Source Han Sans CN";
        font-size: 16px;
        font-style: normal;
        line-height: 32px;
        font-weight: 400;
        /* 200% */
        letter-spacing: -0.16px;
        font-size: 16px;

        strong {
            font-weight: 700;
        }
    }
}


.bd-intro-box {
   // margin-top: 50px;
    //margin-bottom: 50px;
}

.bd-intro-content {
    background: #f4fafa;
    border: 1px solid #e2f0f0;
    border-radius: 8px;
    padding: 24px;
  //  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.bd-intro-image {
    width: 100%;
    margin-bottom: 24px;
    text-align: center;
}

.bd-intro-image img {
    max-width: 100%;
    height: auto;
   // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.bd-intro-text {
    width: 100%;
}

.bd-intro-para {
    color: #494949;
    text-align: justify;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -0.16px;
    margin: 0 0 20px 0;
}

.bd-intro-para:last-child {
    margin-bottom: 0;
}

.bd-section {
    margin-top: 50px;
}

.bd-section-title {
    position: relative;
    color: #000;
    text-align: justify;
    font-family: "Source Han Sans CN";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    /* 133.333% */
    letter-spacing: -0.24px;
    padding-left: 16px;
    margin: 0 0 24px 0;
}

.bd-section-title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    width: 8px;
    height: 28px;
    background: linear-gradient(264deg, #C7AE7A -12.06%, #9DC4A1 12.57%, #0095A3 70.41%, #007DB0 95.04%);
}

.bd-body p {

    color: #494949;
    text-align: justify;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    /* 200% */
    letter-spacing: -0.16px;
    margin: 0 0 32px 0;
}

.bd-organizers {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
}

.bd-org-group {
    background: #f4fafa;
    border: 1px solid #e2f0f0;
    border-radius: 8px;
    padding: 12px 16px;
}

.bd-org-label {
    font-weight: 600;
    color: #037698;
    margin-bottom: 6px;
}

.bd-org-group ul {
    margin: 0;
    padding-left: 18px;
}

.bd-timeline {
    position: relative;
}

.bd-timeline::before {
    content: '';
    position: absolute;
    left: 24px;
    top: 12px;
    bottom: 24px;
    width: 1px;
    background: #037698;
}

.bd-timeline-item {
    position: relative;
    margin-bottom: 12px;
    padding-left: 48px;
    display: flex;
    align-items: flex-start;
}

.bd-timeline-dot {
    position: absolute;
    left: 15px;
    top: 4px;
    width: 18px;
    height: 18px;
    background-color: white;
    border-radius: 50%;
    border: 5px solid #037698;
    z-index: 1;
}

.bd-timeline-content {
    flex: 1;
    display: flex;
}

.bd-timeline-time {
    color: #494949;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.16px;
    margin-bottom: 12px;
    flex-basis: 146px;
}

.bd-timeline-title {
    flex: 1;
    color: #494949;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    /* 200% */
    letter-spacing: -0.16px;
}

.bd-timeline-title strong {
    font-weight: 700;
}

.bd-timeline-li {
    margin: 8px 0 0 20px;
    position: relative;
}

.bd-timeline-li::before {
    content: '●';
    position: absolute;
    left: -12px;
    color: #494949;
    font-size: 8px;
    top: 1px;
}

.bd-timeline-desc {
    color: #494949;
    font-family: "Source Han Sans CN";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.14px;
    margin-top: 8px;
    padding-left: 16px;
}

.bd-timeline-desc strong {
    font-weight: 700;
}

.bd-note {
    margin-top: 34px;
    color: #494949;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    /* 200% */
    letter-spacing: -0.16px;
}

.bd-note::before {
    content: "";
    display: block;
    height: 1px;
    background: #CCC;
    margin-bottom: 12px;
}

.bd-link {
    color: #037698;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    /* 200% */
    letter-spacing: -0.16px;
    cursor: pointer;
}

.bottom {
    margin-bottom: 82px;
}

.bd-two-col {
    display: flex;
    gap: 16px;
}

.bd-two-col .left-img {
    width: 194px;
    height: 170px;
    flex-shrink: 0;
    aspect-ratio: 97/85;
    object-fit: cover;
}

.bd-two-col .right-text {
    color: #494949;
    text-align: justify;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    /* 200% */
    letter-spacing: -0.16px;
    margin: 0;
}

.bd-invitation {
    // margin-top: 60px;
    //padding: 24px 20;
}

.bd-invitation-content {
    text-align: left;
}

.bd-organizations {
    margin-top: 40px;
    margin-bottom: 82px;
}

.bd-page::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: calc(40px + 32px + 2 * (24px + 170px + 24px) + 32px + 82px);
    background: linear-gradient(180deg, rgba(185, 247, 195, 0.00) 6.92%, rgba(185, 247, 195, 0.13) 52.48%, rgba(130, 233, 250, 0.48) 134.9%);
    pointer-events: none;
    z-index: 0;
}

.bd-org-descriptions {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.bd-org-item {
    display: flex;
    gap: 15px;
    padding: 24px;
    align-items: flex-start;
    background-color: white;
    align-items: center;
}

.bd-org-logo {
    flex-shrink: 0;
    width: 194px;
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 12px;
    flex: 1;
}

.bd-org-logo img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.bd-org-text {
    flex: 2;
}

.bd-org-text p {
    color: #494949;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.16px;
    margin: 0;
    text-align: justify;
}

@media screen and (max-width: 767px) {
    .bd-content {
        padding: 0 1rem;
    }

    .bd-title {
        font-size: 24px;
        margin: 24px 0 24px 0;

        .sub-title-images {
            gap: 8px;
            margin-top: 24px;

            img {
                max-width: 100%;
            }
        }
    }

    .bd-timeline-content {
        flex-direction: column;

        .bd-timeline-time {
            flex: 1;
            margin-bottom: 0;
        }

        .bd-timeline-li {
            margin: 0 0 0 12px;
        }
    }

    .bd-org-item {
        flex-direction: column;
        align-items: center;
        padding: 1rem;
    }

    .bd-intro-content {
        padding: 16px;
    }

    .bd-intro-image {
        margin-bottom: 16px;
    }

    .bd-intro-para {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 16px;
    }
}
</style>
